import React from 'react';
import { AlertCircle, ExternalLink } from 'lucide-react';

const DemoNotice: React.FC = () => {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
  const isDemoMode = !supabaseUrl || !supabaseAnonKey ||
                     supabaseUrl === 'https://demo-supabase-url.supabase.co' ||
                     supabaseAnonKey === 'demo-anon-key-placeholder';

  if (!isDemoMode) return null;

  return (
    <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-6 rounded-r-lg shadow-sm">
      <div className="flex">
        <div className="flex-shrink-0">
          <div className="p-1 bg-blue-100 rounded-full">
            <AlertCircle className="h-5 w-5 text-blue-600" />
          </div>
        </div>
        <div className="ml-4">
          <p className="text-sm text-blue-800 font-semibold mb-2">
            <strong>Demo Mode:</strong> This is a demonstration of the LifeShare platform.
          </p>
          <p className="text-sm text-blue-700 mb-3 leading-relaxed">
            Authentication and database features are disabled. To enable full functionality, 
            please set up your Supabase credentials.
          </p>
          <div className="mt-3">
            <a 
              href="https://supabase.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center text-blue-700 hover:text-blue-900 text-sm font-bold bg-blue-100 hover:bg-blue-200 px-3 py-2 rounded-lg transition-colors border border-blue-300 hover:border-blue-400"
            >
              Get started with Supabase
              <ExternalLink className="ml-2 h-3 w-3" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoNotice;